import React from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../shadcn/ui/dialog';
import { Button } from '../shadcn/ui/button';

const DeleteConfirmationDialog = ({ isOpen, onClose, onDelete, confirmationTitle, confirmationMessage }) => {
    const handleConfirmDelete = () => {
        onDelete();
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>{confirmationTitle}</DialogTitle>
                </DialogHeader>
                <p className="mb-4">{confirmationMessage}</p>
                <DialogFooter>
                    <Button onClick={onClose}>Ματαίωση</Button>
                    <Button variant="destructive" onClick={handleConfirmDelete}>Διαγράφη</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
